export default "__VITE_ASSET__B1djFBI0__"